import { Col, Form, Image, OverlayTrigger, Tooltip } from "react-bootstrap"
import { v4 as uuidv4 } from "uuid";

const MoleculeImageLable = ({ img, text, tooltip, width = "50%" }) => {
    const uniqueId = uuidv4()
    return (
        <Col className="text-center mb-3">
            {/* Icon Info với Tooltip */}
            {(tooltip != null) && <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{tooltip}</Tooltip>}
            >
                <Image
                    src={img}
                    rounded
                    fluid
                    width={width}
                />

            </OverlayTrigger>}
            {(tooltip == null) &&
                <Image
                    src={img}
                    rounded
                    fluid
                    width={width}
                />}
            <div className="mt-1">{text}</div>
        </Col>
    )
}

export default MoleculeImageLable